import { createContext } from "react";

const SliderMasterContext = createContext({});

export default SliderMasterContext;
